import { api } from "./authService";

const semesterService = {
  // Alle Semester abrufen
  getAllSemesters: async () => {
    try {
      const response = await api.get("/semesters");
      return response.data;
    } catch (error) {
      console.error("Error fetching semesters:", error);
      throw error;
    }
  },

  // Alias für getAllSemesters für Konsistenz
  getSemesters: async () => {
    return semesterService.getAllSemesters();
  },

  // Semester anhand ID abrufen
  getSemesterById: async (id) => {
    try {
      const response = await api.get(`/semesters/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching semester ${id}:`, error);
      throw error;
    }
  },

  // Semester für eine bestimmte Schule abrufen
  getSemestersBySchool: async (schoolId) => {
    try {
      const response = await api.get(`/semesters/school/${schoolId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching semesters for school ${schoolId}:`, error);
      throw error;
    }
  },

  // Semester für eine bestimmte Klasse abrufen (neue unabhängige Architektur)
  getSemestersByClass: async (schoolId, classId) => {
    try {
      const response = await api.get(`/semesters/class/${schoolId}/${classId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching semesters for school ${schoolId}, class ${classId}:`, error);
      throw error;
    }
  },

  // Neues Semester erstellen
  createSemester: async (semesterData) => {
    try {
      const response = await api.post("/semesters", semesterData);
      return response.data;
    } catch (error) {
      console.error("Error creating semester:", error);
      throw error;
    }
  },

  // Semester aktualisieren
  updateSemester: async (id, semesterData) => {
    try {
      const response = await api.put(`/semesters/${id}`, semesterData);
      return response.data;
    } catch (error) {
      console.error(`Error updating semester ${id}:`, error);
      throw error;
    }
  },

  // Semester löschen
  deleteSemester: async (id) => {
    try {
      await api.delete(`/semesters/${id}`);
    } catch (error) {
      console.error(`Error deleting semester ${id}:`, error);
      throw error;
    }
  },
};

export default semesterService;